module.exports = __webpack_public_path__ + "img/8.ff6a50f9.jpg";